import { render, staticRenderFns } from "./SubjectStatusSelect.vue?vue&type=template&id=0468ca4d&scoped=true&"
import script from "@/components/subject-status-select/SubjectStatusSelect.ts?vue&type=script&lang=ts&"
export * from "@/components/subject-status-select/SubjectStatusSelect.ts?vue&type=script&lang=ts&"
import style0 from "@/components/subject-status-select/subject-status-select.scss?vue&type=style&index=0&id=0468ca4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0468ca4d",
  null
  
)

export default component.exports